@import '../../../../../../constants/spacing.module.less';

.schedule-appointment-button {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: @space-8;
}

.external-link-icon-button {
  width: 14px;
  height: 14px;
}
